import PublicShell, { LegalPage, LegalSection } from "@/components/PublicShell";
import { SITE } from "@/lib/siteInfo";

export default function Terms() {
  const entity = SITE.regNumber ? `${SITE.legalName} (reg. ${SITE.regNumber})` : SITE.legalName;
  return (
    <PublicShell testId="terms-page">
      <LegalPage
        title="Terms of Service"
        subtitle={`These terms govern your use of Sliply (${SITE.domain}), operated by ${entity}. By creating an account or using the service, you agree to them.`}
        updated={SITE.effectiveDate}
        testId="terms-content"
      >
        <LegalSection n="1" title="Who we are">
          <p>
            Sliply is an AI-powered receipt management and spending-intelligence service that lets you capture
            receipts, organise spending, compare prices, track warranties and generate reports. The service is
            operated by {entity} ("Sliply", "we", "us"). You can reach us at {SITE.email}
            {SITE.phone ? ` or ${SITE.phone}` : ""}.
          </p>
        </LegalSection>

        <LegalSection n="2" title="Your account">
          <p>You must provide accurate information when registering and keep your login credentials secure. You are responsible for all activity under your account. You must be at least 18 years old, or have the consent of a parent or guardian, to use Sliply.</p>
        </LegalSection>

        <LegalSection n="3" title="Plans, billing & Premium">
          <p>Sliply offers a Free plan and a paid Premium plan. Paid subscriptions renew automatically at the end of each billing cycle (monthly or yearly) until cancelled. Prices are shown in South African Rand (ZAR) and include VAT where applicable.</p>
          <p>Cancellation, renewal and refund terms are set out in our <a href="/refunds" className="text-riq-primary font-semibold hover:underline">Refund &amp; Cancellation policy</a>, which forms part of these terms.</p>
        </LegalSection>

        <LegalSection n="4" title="Acceptable use">
          <p>You agree not to misuse the service, including: uploading unlawful content, attempting to breach security, scraping or reverse-engineering the service, reselling access without permission, or submitting receipts that are fraudulent or do not belong to you. We may suspend or close accounts that abuse the service, our rewards (Moolas) programme, or our anti-fraud rules.</p>
        </LegalSection>

        <LegalSection n="5" title="Your content & data">
          <p>You retain ownership of the receipts and data you upload. You grant us a licence to process that content to provide the service (for example, running OCR and AI extraction, generating reports and, where relevant, contributing <em>anonymised</em> price data to community price comparison). We handle personal information in line with the Protection of Personal Information Act (POPIA).</p>
        </LegalSection>

        <LegalSection n="6" title="AI-generated results">
          <p>Sliply uses automated OCR and AI to read receipts and answer questions. These results can contain errors. You are responsible for reviewing extracted figures (such as totals, dates and VAT) before relying on them for tax, accounting or claims. Sliply is a convenience tool and does not provide financial, tax or legal advice.</p>
        </LegalSection>

        <LegalSection n="7" title="Rewards (Moolas)">
          <p>Moolas and related rewards have no cash value, are not transferable, and may be adjusted, expired or reversed where receipts are removed, duplicated or found to be fraudulent. We may change the rewards programme at any time.</p>
        </LegalSection>

        <LegalSection n="8" title="Availability & changes">
          <p>We aim to keep Sliply available but do not guarantee uninterrupted service. We may add, change or remove features, and may update these terms from time to time. If we make material changes, we will take reasonable steps to notify you. Continued use after changes means you accept the updated terms.</p>
        </LegalSection>

        <LegalSection n="9" title="Liability">
          <p>To the maximum extent permitted by law, Sliply is provided "as is" and we are not liable for indirect or consequential loss, or for loss arising from inaccurate AI/OCR results, lost data, or your reliance on the service. Nothing in these terms limits rights you have under the Consumer Protection Act or other South African law that cannot lawfully be excluded.</p>
        </LegalSection>

        <LegalSection n="10" title="Governing law">
          <p>These terms are governed by {SITE.governingLaw}, and the courts of {SITE.jurisdiction} have jurisdiction over any dispute, subject to your rights under applicable consumer-protection law.</p>
        </LegalSection>

        <LegalSection n="11" title="Contact">
          <p>
            Questions about these terms? Email <a href={`mailto:${SITE.email}`} className="text-riq-primary font-semibold hover:underline">{SITE.email}</a>
            {SITE.phone ? <> or call {SITE.phone}</> : null}.
            {SITE.address ? <><br />{SITE.address}</> : null}
          </p>
        </LegalSection>
      </LegalPage>
    </PublicShell>
  );
}
